import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { getIframePageDecorators } from "../../../shared/page";
import {
    Template as ProductHeaderTemplate,
    templateArgs as productHeaderArgs,
} from "../../partial-templates/nimbus/product-header/product-header.templates";
import {
    Template as ChapterIntroTemplate,
    templateArgs as chapterIntroArgs,
} from "../../partial-templates/nimbus/chapter-intro/chapter-intro.templates";
import { Template as VideoTemplate } from "../../partial-templates/nimbus/video/video.templates";

const Template = () => html`
    <div>
        <div class="ux-t-container-full ux-theme-nimbus">
            ${ProductHeaderTemplate(productHeaderArgs)}
            ${ChapterIntroTemplate(chapterIntroArgs)}
            ${VideoTemplate({ count: 3 })}
        </div>
    </div>
    </div>
`;

export default {
    title: "Website/Page Templates/Nimbus/Product Detail Page",
    render: Template.bind({}),
    decorators: getIframePageDecorators(),
    parameters: {
        layout: "fullscreen",
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

export const Default = {};
